<template>
<div class="router-card">
  <div
    v-for="(item,index) in router"
    @click="route(item.title)"
    class="router-btn"
    :class="{'active':item.active,'disable':!item.active}">
    <div class="left-block" v-show="item.active">

    </div>
    <img :src="'http://data.xiyilab.com/web/main/static'+(item.active?item.icon+'.png':item.icon+'-拷贝.png')" class="img" v-if="item.label!=='实验报告'" width="23px">
    <i v-else class="el-icon-document-copy " style="font-size: 23px;" :style="{color:item.active?'rgb(94, 178, 247)':'black'}"></i>
    <span class="text">{{item.label}}</span>
  </div>
</div>
</template>

<script>
export default {
  name: 'routerList',
  props:{
    activeBtn:{
      type:String
    }
  },

  data(){
    return{
      router:[],
      auth:'',
    }
  },
  created () {
    this.router=JSON.parse(localStorage.getItem('router'))
    this.auth=localStorage.getItem('user_identity')
  },
  mounted () {
    for(let i=0;i<this.router.length;i++){
      if(this.router[i].title===this.activeBtn){
        this.router[i].active=true
      }
      else{
        this.router[i].active=false
      }
    }
    console.log(this.router)
  },
  methods:{
    route(title){
      let clickBtn=this.router.find(item=>item.title===title)
      clickBtn.active=true
      for(let i=0;i<this.router.length;i++){
        if(this.router[i].title!==title){
          this.router[i].active=false
        }
      }
      this.$emit('switchRight',title)
    }
  }
}
</script>

<style scoped>

.router-card{
  background-color:#f8f8f8;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.router-btn{
  height: 3.6vw;
  width: 100%;
  position: relative;
  color:#a0a0a0;
  cursor: pointer;
  justify-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.router-btn:hover{
  background: rgb(248, 248, 248);
  color: #5eb2f7;
}
.active{
  background-color:rgb(248, 248, 248);
  color: #5eb2f7;
}
.disable{

  background-color: white;
}
.left-block{
  position: absolute;
  top:0.8vw;
  width: 0.2vw;
  left: 0;
  height: 2.1vw;
  background-color: rgb(22, 120, 255);

}
.img{
  object-fit: contain;

}
.text{
  height: 3.6vw;
  line-height: 3.6vw;
  font-size: 0.8vw;
  text-align: center;
  margin-left: 2vw;
}
</style>
